import {connect} from '@modifi/redux'
import {aCloseDialog, aShowDialog} from '@modifi/plugin-dialogs'
import PassThroughTransactionDialog, {
  EditTransactionDialogProps,
} from './PassThroughTransactionDialog'
import {aFetchTransaction} from '../../../../data/transaction'
import {
  aPassThroughTransaction,
  aCleanupPassThrough,
  selectPassThroughPending,
  selectPassThroughErrorMessage,
} from '../../../../modules/pass-through-transaction/store'

export const DIALOG_NAME = 'pass-through-transaction'

const mapStateToProps = (
  state: Record<string, any>
): Pick<EditTransactionDialogProps, 'markAsPassThroughIsPending' | 'markAsPassThroughError'> => ({
  markAsPassThroughIsPending: selectPassThroughPending(state),
  markAsPassThroughError: selectPassThroughErrorMessage(state),
})

const mapDispatchToProps = {
  markAsPassThrough: aPassThroughTransaction,
  fetchTransaction: aFetchTransaction,
  cleanupMarkAsPassThrough: aCleanupPassThrough,
  handleClose: aCloseDialog,
  showDialog: aShowDialog,
}

export default connect(mapStateToProps, mapDispatchToProps)(PassThroughTransactionDialog)
